// Deprecated. This is only for back compatibility by tests!
console.warn('Deprecated! Please use require("@iobroker/db-states-redis").Client library in tests!');

import { Client } from '@iobroker/db-states-redis';

export default Client;
